import React from "react";

const QuestCardSkeleton = () => {
  return (
    <div className="bad-quest_card-skeleton">
      <div className="bad-quest_card-skeleton-one">
        <div className="bad-quest_card-skeleton-two">
          <div className="bad-quest_card-skeleton-three">
            <div className="bad-quest_card-skeleton-four"></div>
            <div className="bad-quest_card-skeleton-five"></div>
            <div></div>
          </div>
          <div className="bad-quest_card-skeleton-six">
            <div className="bad-quest_card-skeleton-seven"></div>
            <div className="bad-quest_card-skeleton-eight"></div>
          </div>
          <div className="bad-quest_card-skeleton-one">
            <div className="bad-quest_card-skeleton-nine"></div>
          </div>
        </div>
        <div className="bad-quest_card-skeleton-ten" />
      </div>
    </div>
  );
};

export { QuestCardSkeleton };
